module.exports = __webpack_public_path__ + "img/logo.f8c8b682.png";